import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, X } from 'lucide-react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal-content" onClick={e => e.stopPropagation()}>
        <div className="contact-modal-header">
          <h2 className="contact-modal-title">İletişim</h2>
          <button className="contact-modal-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="contact-modal-body">
          <div className="contact-info-list">
            <a href="tel:+905052149197" className="contact-info-item">
              <div className="contact-info-icon">
                <Phone size={20} />
              </div>
              <div className="contact-info-text">
                <span>+90 505 214 91 97</span>
              </div>
            </a>

            <a href="mailto:hasankorkmaz@remax.com.tr" className="contact-info-item">
              <div className="contact-info-icon">
                <Mail size={20} />
              </div>
              <div className="contact-info-text">
                <span>hasankorkmaz@remax.com.tr</span>
              </div>
            </a>

            <div className="contact-info-item">
              <div className="contact-info-icon">
                <MapPin size={20} />
              </div>
              <div className="contact-info-text">
                <span>RE/MAX West Ofisi<br />Karşıyaka/İzmir</span>
              </div>
            </div>
          </div>

          <div className="contact-social-section">
            <a href="https://www.facebook.com/hasan.korkmaz.3597789?locale=tr_TR" target="_blank" rel="noopener noreferrer" className="contact-social-btn">
              <Facebook size={24} />
            </a>
            <a href="https://www.instagram.com/hasan_korkmaz_remax?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="contact-social-btn">
              <Instagram size={24} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
